<template>
    <div class="topbar">
        <div class="leftside">
            <a href="/admin">
                <img src="/img/menu_logo.svg" alt="logo" />
            </a>
            <div :class="menu ? 'close_menu roll' : 'close_menu'" @click="rollMenu">
                <svg width="10" height="9" viewBox="0 0 10 9" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0.625 0C0.79076 0 0.949732 0.0677294 1.06694 0.188288C1.18415 0.308848 1.25 0.472361 1.25 0.642857V8.35714C1.25 8.52764 1.18415 8.69115 1.06694 8.81171C0.949732 8.93227 0.79076 9 0.625 9C0.45924 9 0.300268 8.93227 0.183058 8.81171C0.065848 8.69115 0 8.52764 0 8.35714V0.642857C0 0.472361 0.065848 0.308848 0.183058 0.188288C0.300268 0.0677294 0.45924 0 0.625 0ZM5.44187 2.11693C5.55904 2.23748 5.62487 2.40097 5.62487 2.57143C5.62487 2.74189 5.55904 2.90537 5.44187 3.02593L4.63375 3.85714H9.375C9.54076 3.85714 9.69973 3.92487 9.81694 4.04543C9.93415 4.16599 10 4.3295 10 4.5C10 4.6705 9.93415 4.83401 9.81694 4.95457C9.69973 5.07513 9.54076 5.14286 9.375 5.14286H4.63375L5.44187 5.97407C5.55572 6.09532 5.61872 6.2577 5.6173 6.42626C5.61587 6.59481 5.55014 6.75605 5.43426 6.87524C5.31838 6.99443 5.16162 7.06204 4.99775 7.0635C4.83388 7.06497 4.676 7.00017 4.55813 6.88307L2.68313 4.9545C2.56596 4.83395 2.50013 4.67046 2.50013 4.5C2.50013 4.32954 2.56596 4.16605 2.68313 4.0455L4.55813 2.11693C4.67533 1.99641 4.83427 1.92871 5 1.92871C5.16573 1.92871 5.32467 1.99641 5.44187 2.11693Z"
                        fill="white" />
                </svg>
            </div>
        </div>
        <div class="rightside">
            <div class="left">
                <div v-if="!is_paid" class="max_offer_client">
                    <max-offer-client :numerator="offer_count" :denominator="3" title="Vytvorených ponúk"></max-offer-client>
                    <max-offer-client :numerator="klient_count" :denominator="3" title="Vytvorených klientov"></max-offer-client>
                </div>
            </div>
            <div class="right">
                <div class="picture" @click="profil">
                    {{ picture() }}
                </div>
                <div class="name">
                    <h3 @click="profil">
                        {{ data.auth.meno }} {{ data.auth.priezvisko }}
                    </h3>
                    <a v-if="nice_paid_type" href="/admin/subscriptions/dashboard" class="subscription-link"
                        :class="is_paid ? 'paid' : 'free'">
                        <svg v-if="is_paid" width="9" height="8" viewBox="0 0 9 8" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.777064 1.04341L2.55721 2.56592L4.1432 0.667779C4.18761 0.614714 4.24376 0.572071 4.30748 0.543026C4.37119 0.513982 4.44083 0.499284 4.5112 0.500027C4.58157 0.50077 4.65087 0.516935 4.71392 0.547318C4.77697 0.577701 4.83216 0.621519 4.87537 0.67551L6.38885 2.56547L8.22653 1.02112C8.2987 0.960599 8.38816 0.922946 8.48295 0.913201C8.57774 0.903457 8.67332 0.922086 8.75692 0.966597C8.84051 1.01111 8.90813 1.07937 8.95071 1.16226C8.9933 1.24515 9.00882 1.3387 8.9952 1.4304L8.29344 6.13574H0.717648L0.00512243 1.45177C-0.00903114 1.35957 0.00631304 1.26536 0.0490766 1.18191C0.0918401 1.09846 0.159956 1.0298 0.2442 0.985237C0.328443 0.940671 0.424743 0.92235 0.520056 0.932754C0.615369 0.943159 0.705089 0.981786 0.777064 1.04341ZM0.75414 6.59049H8.23963V7.04525C8.23963 7.16585 8.19034 7.28152 8.10261 7.36681C8.01487 7.45209 7.89587 7.5 7.77179 7.5H1.22198C1.0979 7.5 0.978906 7.45209 0.891168 7.36681C0.80343 7.28152 0.75414 7.16585 0.75414 7.04525V6.59049Z"
                                fill="#FEF3C7" />
                        </svg>
                        {{ nice_paid_type }}
                    </a>
                </div>
                <div class="settings" @click="profil">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M7.04297 1.21899C6.77697 0.126994 5.22297 0.126994 4.95697 1.21899C4.91726 1.38308 4.83936 1.53548 4.72963 1.66378C4.61989 1.79208 4.48141 1.89266 4.32546 1.95733C4.16951 2.02201 4.0005 2.04894 3.83217 2.03596C3.66384 2.02297 3.50096 1.97042 3.35677 1.88259C2.39637 1.29739 1.29737 2.39639 1.88257 3.35679C2.26057 3.97699 1.92527 4.78619 1.21967 4.95769C0.126972 5.22299 0.126972 6.77769 1.21967 7.04229C1.38381 7.08206 1.53623 7.16002 1.66453 7.26984C1.79283 7.37966 1.89338 7.51823 1.95799 7.67427C2.0226 7.8303 2.04945 7.99939 2.03634 8.16776C2.02323 8.33614 1.97055 8.49904 1.88257 8.64319C1.29737 9.60359 2.39637 10.7026 3.35677 10.1174C3.50093 10.0294 3.66383 9.97673 3.8322 9.96362C4.00057 9.95052 4.16966 9.97737 4.3257 10.042C4.48173 10.1066 4.6203 10.2071 4.73012 10.3354C4.83994 10.4637 4.91791 10.6162 4.95767 10.7803C5.22297 11.873 6.77767 11.873 7.04227 10.7803C7.08217 10.6162 7.16021 10.4639 7.27006 10.3357C7.3799 10.2075 7.51845 10.107 7.67443 10.0424C7.83042 9.97783 7.99944 9.95096 8.16777 9.96399C8.3361 9.97701 8.49898 10.0296 8.64317 10.1174C9.60357 10.7026 10.7026 9.60359 10.1174 8.64319C10.0296 8.499 9.97699 8.33612 9.96396 8.1678C9.95094 7.99947 9.97781 7.83044 10.0424 7.67445C10.107 7.51847 10.2075 7.37992 10.3357 7.27008C10.4639 7.16023 10.6162 7.08219 10.7803 7.04229C11.873 6.77699 11.873 5.22229 10.7803 4.95769C10.6161 4.91793 10.4637 4.83996 10.3354 4.73014C10.2071 4.62032 10.1066 4.48175 10.042 4.32572C9.97734 4.16968 9.9505 4.0006 9.9636 3.83222C9.97671 3.66385 10.0294 3.50095 10.1174 3.35679C10.7026 2.39639 9.60357 1.29739 8.64317 1.88259C8.49901 1.97057 8.33612 2.02326 8.16774 2.03636C7.99937 2.04947 7.83028 2.02262 7.67425 1.95801C7.51821 1.8934 7.37964 1.79285 7.26982 1.66455C7.16 1.53625 7.08204 1.38383 7.04227 1.21969L7.04297 1.21899ZM5.99997 8.09999C6.55693 8.09999 7.09107 7.87874 7.4849 7.48492C7.87872 7.09109 8.09997 6.55695 8.09997 5.99999C8.09997 5.44304 7.87872 4.9089 7.4849 4.51507C7.09107 4.12124 6.55693 3.89999 5.99997 3.89999C5.44302 3.89999 4.90887 4.12124 4.51505 4.51507C4.12122 4.9089 3.89997 5.44304 3.89997 5.99999C3.89997 6.55695 4.12122 7.09109 4.51505 7.48492C4.90887 7.87874 5.44302 8.09999 5.99997 8.09999Z"
                            fill="#263544" />
                    </svg>
                </div>
                <div class="logout" @click="logout">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.1733 8.52832L11.6667 7.03499L10.1733 5.54166" stroke="#212541" stroke-width="1.5"
                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M5.69336 7.03497H11.6259" stroke="#212541" stroke-width="1.5" stroke-miterlimit="10"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M6.86003 11.6667C4.28169 11.6667 2.19336 9.91668 2.19336 7.00001C2.19336 4.08334 4.28169 2.33334 6.86003 2.33334"
                            stroke="#212541" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MaxOfferClient from './MaxOfferClient.vue';
export default {
    components: {
        MaxOfferClient
    },
    props: ["data", "nice_paid_type","is_paid","offer_count","klient_count"],
    data() {
        return {
            menu: false,
        };
    },
    created() {
        if (localStorage.getItem("menu")) {
            this.menu = true;
        }
    },
    methods: {
        rollMenu() {
            if (!this.menu) {
                this.menu = true;
                localStorage.setItem("menu", "roll");
                $(".menuleft").addClass("hide");
                $(".pcoded-content").addClass("hide");
            } else {
                this.menu = false;
                localStorage.removeItem("menu");
                $(".menuleft").removeClass("hide");
                $(".pcoded-content").removeClass("hide");
            }
        },
        picture() {
            if (this.data.auth.meno != null && this.data.auth.priezvisko != null) {
                var one = this.data.auth.meno.charAt(0).toUpperCase();
                var two = this.data.auth.priezvisko.charAt(0).toUpperCase();
                return one + two;
            } else if (this.data.auth.meno != null) {
                return this.data.auth.meno.charAt(0).toUpperCase();
            } else {
                return '';
            }
        },
        premium() {
            //window.location.href = '/admin/balicky';
        },
        profil() {
            window.location.href = "/admin/nastavenia/ucet";
        },
        logout() {
            $("#logout-form").submit();
        },
    },
};
</script>

<style lang="scss" scoped>
.topbar {
    display: flex;
    height: 90px;

    @media only screen and (max-width: 1100px) {
        display: none;
    }

    .leftside {
        width: 300px;
        background: linear-gradient(0deg, #212541, #212541), #ffffff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px 0 32px;

        img {
            width: 141px;
        }

        .close_menu {
            width: 20px;
            height: 20px;
            background: rgba(255, 255, 255, 0.15);
            border-radius: 6px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            svg {
                transition: 0.5s all;
            }

            &.roll {
                svg {
                    transform: rotate(180deg);
                }
            }
        }
    }

    .rightside {
        width: calc(100% - 300px);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px 0 37px;

        .left {
            h3 {
                font-family: Montserrat;
                font-style: normal;
                font-weight: bold;
                font-size: 20px;
                line-height: 110%;
                color: #212541;
                margin: 0 0 4px 0;
            }

            p {
                font-family: Montserrat;
                font-style: normal;
                font-weight: 600;
                font-size: 10px;
                line-height: 12px;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                color: #f3385a;
                margin: 0;
            }
            .max_offer_client{
                display: flex;
                align-items: center;
                gap: 30px;
            }
        }

        .right {
            display: flex;
            align-items: center;

            .picture {
                width: 50px;
                height: 50px;
                background: rgba(249, 60, 52, 0.12);
                border-radius: 50px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: Montserrat;
                font-style: normal;
                font-weight: 600;
                font-size: 16px;
                line-height: 20px;
                color: #f93c34;
                margin-right: 11px;
                cursor: pointer;
            }

            .name {
                display: block;
                align-items: center;

                h3 {
                    font-family: Montserrat;
                    font-style: normal;
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 20px;
                    color: #212541;
                    margin: 0 0 2px 0;
                    cursor: pointer;
                }

                .subscription-link {
                    width: fit-content;
                    height: 20px;
                    border-radius: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 5px;
                    padding: 0 9px;
                    font-family: Montserrat;
                    font-style: normal;
                    font-weight: 600;
                    font-size: 10px;
                    letter-spacing: 0.12em;
                    text-transform: uppercase;
                    text-decoration: none;
                    color: #ffffff;
                    cursor: pointer;

                    &.paid {
                        background: #FBBF24;
                    }

                    &.free {
                        background: #F94841;
                    }
                }
            }

            .settings {
                width: 22px;
                height: 22px;
                border: 1px solid #f2f2f2;
                box-sizing: border-box;
                border-radius: 6px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 19px;
                margin-left: 27px;

                &:hover {
                    background: #f2f2f2;
                }

                cursor: pointer;
            }

            .logout {
                width: 22px;
                height: 22px;
                border: 1px solid #f2f2f2;
                box-sizing: border-box;
                border-radius: 6px;
                display: flex;
                align-items: center;
                justify-content: center;

                &:hover {
                    background: #f2f2f2;
                }

                cursor: pointer;
            }
        }
    }
}
</style>
